import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { Observable } from 'rxjs';
import { ordersService } from '../../services/orders.service';
import { NeAddOrderComponent } from '../ne-add-order/ne-add-order.component';
import { AddComponentComponent } from '../add-component/add-component.component';
import { RemoveComponentComponent } from '../remove-component/remove-component.component';
import { error } from 'jquery';
import { ExchangeComponentComponent } from '../exchange-component/exchange-component.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders-details.component.html',
  styleUrls: ['./orders-details.component.css']
})
export class ordersDetailsComponent {
  theme = 'dark'
  pageSize = 100; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC'
  tableName = 'orderTable'
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  // filters= [];
  filters: any[] = [];

  userType: any;
  columns = [
    { showColumn: true, sortingColumn: '', key: 'truckNumber', header: 'Truck Number', sortable: false, viewDialog: true, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'componentType', header: 'Component Type', sortable: false, type: 'text', viewDialog: false },
    { showColumn: true, sortingColumn: '', key: 'serialNumber', header: 'Serial Number', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: '',  key: 'from', header: 'From', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: '',  key: 'initialKmTraelled', header: 'KMs (Association)', sortable: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'status', header: 'To', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'initialKmTraelled', header: 'KMs (Disassociation)', sortable: false, type: 'invoicedate' },
    { showColumn: true, sortingColumn: '', key: 'status', header: 'Rinning Status', sortable: false, type: 'RouteDetails' },
    { showColumn: true, sortingColumn: '', key: 'Action', header: 'Action', sortable: false, viewDialog: false, type: 'text' },
    {showColumn: true, sortingColumn: 'createdAt',  key: 'createdAt', header: 'Created At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'createdByName', header: 'Created By', sortable: false, type: 'text' },
    {showColumn: true, sortingColumn: 'updatedAt',  key: 'updatedAt', header: 'Updated At', sortable: true, type: 'date' },
    {showColumn: true, sortingColumn: '',  key: 'updatedByName', header: 'Updated By', sortable: false, type: 'text' },

  ];

  columnsToExport: string[] = ['financialYearId', 'budgetDate', 'budgetType', 'reference', 'accountName', 'warehouseName', 'approvedBudget', 'expense', 'createdAt', 'createdByName', 'updatedAt', 'updatedByName', 'budgetProof', 'remarks'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };
  componentList = [
  { name: 'Tyre', value: 'Tyre' },
  { name: 'Battery', value: 'Battery' },
  { name: 'Insurance', value: 'Insurance' },
  { name: 'Puc', value: 'Puc' },
  { name: 'FastTag', value: 'FastTag' },
  { name: 'Repair & Maintenance', value: 'RepairAndMaintenance' },
  { name: 'Trailer', value: 'Trailer' }
];

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  truckDetails: any;
  truckTranscations: any;
  statusCount: any;
  totalElements: any;
  constructor(private ordersService: ordersService,private route: ActivatedRoute,
    private primengConfig: PrimeNGConfig, private fb: FormBuilder, private tabService: TabService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null)
  });

  ngOnInit(): void {
     if (this.route.snapshot.params['id']) {
        this.getTruckBuildById(this.route.snapshot.params['id'])
      }else {
        // this.viewOrderDetails();
      }
      // this.selectTab('shipment',this.route.snapshot.params['id'])
    this.getTruckTransactions()
  }

getTruckBuildById(id: any) {
  // this.isShipmentNotFound = false;
  this.ordersService.getTruckBuildById(id).subscribe((res: any) => {
    this.truckDetails = res.responseObject;   

    if(this.truckDetails){
      this.getTruckTransactions()
    }
  })
}

getTruckTransactions() {
  const postData = [
      // {
      //   key: 'COMPONENT_TYPE_IN',
      //   value: type,
      // },
      {
        key: 'TRUCK_BUILD_ID_IN',
        value: this.truckDetails?.id,
      },
    ];
    console.log(postData)
    if(this.filters.length > 1){

    }else{
      this.filters = postData
    }
  //  const postData = [
  //     {
  //       key: 'TRUCK_BUILD_ID_IN',
  //       value: this.truckDetails?.id,
  //     },
  //   ];
  // this.isShipmentNotFound = false;
  this.ordersService.getTruckTransactions(this.filters, this.pageNumber, this.pageSize, this.sortingCol, this.direction).subscribe((res: any) => {
    this.truckTranscations = res.responseObject?.content;   
    this.totalElements = res?.responseObject?.totalElements
    const statusCount: any = {};

    this.truckTranscations.forEach((item: any) => {
      const status = item.status;

      if (!statusCount[status]) {
        statusCount[status] = 0;
      }

      statusCount[status]++;
    });
    this.statusCount = statusCount
    console.log(statusCount);

  },error => {
    this.truckTranscations = [],
    this.totalElements = 0
    this.statusCount =  0
  })
}

  getWarehouseDetails(pageIndex: number, pageSize: number, filter: any) {
    // const warehouseFilter = this.setFilter();
    this.warehouseData = []
    this.totalCount = 0
    // this.warehouseService.getWarehouseList(pageIndex, pageSize, filter).subscribe((res: any) => {
    //   this.warehouseData = res?.responseObject?.content;
    //   this.totalCount = res?.responseObject?.totalElements;
    // })
  }

  
  reloadEvent(event:any){
    console.log(event);
    // this.getList()
  }



  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {}, pageNumber = 0, pageSize = 250, sortingCol = 'id',
      direction = 'DESC'
    } = params;

    return this.ordersService.getOrders(
      filters, pageNumber, pageSize, sortingCol, direction
    );
  };

  onFilterChange(event: any) {
    if (event) {
      console.log(event)
      this.filters = event
      // this.getList()
    }
  }

  onResetFilters() {
    this.filters = []
    // this.getList()
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.currentPage = event.pageIndex
  }

  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(localStorage.getItem('columnToExport') || '{}');

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type: any) {
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      // header: `${type} Order`,
      header: `Assemble Truck`,
      data: type == 'Add' ? {} : {
        editData: this.selectedData,
        edit: this.editContation
      },
      width: '90vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
    });
  }



  receiveDataEvent(data: any[]) {
    console.log(data)
    this.selectedData = data
  }
  editEvent() {
    this.editContation = true
    console.log(this.editContation)
    this.addBudget('Edit')
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.masterServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    console.log(this.selectedData)
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.masterServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }


  upload(url: any, params: any) {
    this.tabService.addTab({
      label: 'Upload', path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate([url], { queryParams: params })
  }
 goBack() {
    this.tabService.addTab({
      label: 'Truck Mapping', path: '/truck-mapping',
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate(['/truck-mapping'])
  }

  addComponentPopUp(truckDetails:any){
    this.ref = this.dialogService.open(AddComponentComponent, {
      // header: `${type} Order`,
      header: `Add Component`,
      data:  {
        data: truckDetails,
        
      },
      width: '50vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getTruckBuildById(this.route.snapshot.params['id'])

    });
  }
  removeComponentPopUp(truckDetails:any){
    this.ref = this.dialogService.open(RemoveComponentComponent, {
      // header: `${type} Order`,
      header: `Remove Component`,
      data:  {
        data: truckDetails,
        truckTranscations: this.truckTranscations
      },
      width: '55vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getTruckBuildById(this.route.snapshot.params['id'])

    });

}

 onChangeComponent(type:any){
    console.log(type)
    // this.componentType = type

    const postData = [
      {
        key: 'COMPONENT_TYPE_IN',
        value: type,
      },
      {
        key: 'TRUCK_BUILD_ID_IN',
        value: this.truckDetails?.id,
      },
    ];
    console.log(postData)
    this.filters = postData
    this.getTruckTransactions()
    // this.ordersService.getTruckBuildById(postData).subscribe((data: any) => {

    // })
  }
  sortData(key: string) {
  // this.sortingCol, this.direction
    if (this.sortingCol === key) {
      this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortingCol = key;
      this.direction = 'ASC';
    }
    this.getTruckTransactions()
  }


  
  exchangeComponentPopUp(truckDetails:any) {
    this.ref = this.dialogService.open(ExchangeComponentComponent, {
      // header: `${type} Order`,
      header: `Exchange Component`,
      data: {
        data: truckDetails,
        // edit: this.editContation
      },
      width: '50vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      // this.getList();
      this.getTruckBuildById(this.route.snapshot.params['id'])
      this.selectedRows = [];
    });
  }

}